/* eslint-disable complexity */
/* eslint-disable extra-rules/no-commented-out-code */
/* eslint-disable max-lines */
import isEmpty from 'lodash/isEmpty';
import { call, put, select, takeLatest, fork, delay } from 'redux-saga/effects';
import { isClient, getAPIConfig } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getModuleDynamic } from '@tcp/core/src/services/abstractors/common/moduleDynamic';
import {
  getIsHorizontalPlpEnabled,
  getIsAlternatePLPEnabled,
  getPaginatedAlternatePLPCatIds,
  getIsPaginatedAlternatePLPEnabled,
  getIsOutfitPLPEnabled,
  getIsHplpFiltersEnabled,
  getHorizontalCarouselPLPCatIds,
  getIsFacetedNavigationEnabled,
  getSeoFacetedNavigationConfig,
  getIsCleanUrlForSizeEnabled,
  getIsESpotPlpBackABTest,
  getIsESpotPromoL2PlpWithCategoryBreakEnabled,
  getIsESpotPromoL1PlpEnabled,
  getIsESpotPromoL2PlpEnabled,
  getIsESpotPromoL3PlpEnabled,
  getIsStageHoldCategoriesOosEnabled,
  getIsQuickFiltersModuleEnabled,
  getIsQuickFiltersEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import fetchPlpProducts, {
  getSeoTokenJSONList,
} from '@tcp/core/src/services/abstractors/categoryListing/categoryListing';
import {
  getFiltersAfterProcessing,
  getModuleFilters,
  isAppliedFitersObjectEmpty,
  hasSelectedFacets,
  extractQuickFiltersFromFilters,
} from '@tcp/core/src/services/abstractors/productListing/processResponse';
import CATEGORY_LISTING_PAGE_CONSTANTS from './CategoryListingPage.constants';
import {
  setPaginatedPlpLoading,
  resetPaginatedProducts,
  setConsolidatedPlpRes,
  setPaginatedPlpData,
  setCurrentPageNo,
  setCurrNavIds,
  resetCachedTiming,
  setHorizontalPlpFlag,
  setBucketedPaginatedProducts,
  setServiceErrorFlag,
  setAlternatePlpFlag,
  setPaginatedAlternatePlpFlag,
  updateAppliedFilter,
  resetSeoHeaderCopyLoadedFlag,
  setIsProductLoading,
  setSEOTokenJSON,
  updateFilterFromURL,
  setStageHoldCategoryFlag,
  setCategoryModuleFilters,
  setQuickFilters,
  setSubCatFacetList,
  setSubCatFilterMapsData,
  resetSubCatFilterMapsLoadedFlag,
  setSubCategoryFilterLoading,
  setBucketLoadingFlag,
} from './CategoryListingPage.actions';
import {
  getCategoryProducts,
  getBreadCrumbs,
  getUnbxdCallByPageNumber as getUnbxdPageNo,
  computedBreadCrumbs,
  getInitialValues,
  isCachedTimeOver,
  getFilterMaps,
  getNavigationData,
  getLayoutProductListingPageData,
  getSeoTokens,
  getSubCatFacetList,
  getSubCatFilterMapsLoaded,
  getSubCatFilterMaps,
} from './CategoryListingPage.selectors';
import { bootstrap } from '../../../../../reduxStore/sagas/bootstrap';
import { fetchModulesAndLayout } from '../../ProductListing/container/ProductListing.saga';
import {
  getL2BucketingByPageNumber,
  getUnbxdCallByPageNumber,
  getFiltersPayload,
  getFiltersPayloadSeo,
  extractFilters,
  getFacetSwatchImgPath,
  getAppliedFilters,
  l3Check,
  navigationToLastPage,
  getNavigationTree,
  getplpHlpAplpChecks,
  getPlpPayload,
  resolveCategoryCall,
  parseContentData,
  getIsL2Category,
  findESpotPlpPromo,
  findESpotById,
  containsOnlyOneKey,
  hasOnlyPageParam,
  filterFacetValues,
  getSubCategoryForFiltering,
  getAppliedSubCatFilters,
  getUpdatedFacetsList,
} from './CategoryListingPage.utils';
import {
  fetchHorizontalCategoryProducts,
  getUnbxdXappConfigs,
} from '../../HorizontalCategory/container/HorizontalCategory.saga';
import { loadLayoutData } from '../../../../../reduxStore/actions';
// import { setLocalStorage } from '../../../../../utils/localStorageManagement';

async function getESpotPlpPromo({
  breadCrumbs,
  isESpotPromoL1PlpEnabled,
  isESpotPromoL2PlpEnabled,
  isESpotPromoL3PlpEnabled,
  isESpotPromoL2PlpWithCategoryBreakEnabled,
}) {
  let eSpotPlpPromoData = null;
  try {
    eSpotPlpPromoData = await findESpotPlpPromo({
      breadCrumbs,
      isESpotPromoL1PlpEnabled,
      isESpotPromoL2PlpEnabled,
      isESpotPromoL3PlpEnabled,
      isESpotPromoL2PlpWithCategoryBreakEnabled,
    });
  } catch (error) {
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - getESpotPlpPromo catch - ${error}`,
      extraData: {
        componentName: 'CategoryListingPageSaga',
        methodName: 'getESpotPlpPromo',
        isServiceError: error?.isServiceError || false,
      },
    });
  }
  return eSpotPlpPromoData;
}

export function* fetchModuleDynamic({ espotContentId, id, typeName = 'EspotPlpSection' }) {
  let eSpotPlpPromoModuleData = null;
  try {
    eSpotPlpPromoModuleData = yield call(getModuleDynamic, espotContentId, id, typeName);
  } catch (error) {
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - fetchModuleDynamic catch - ${error}`,
      extraData: {
        componentName: 'CategoryListingPageSaga',
        methodName: 'fetchModuleDynamic',
        isServiceError: error?.isServiceError || false,
      },
    });
  }
  return eSpotPlpPromoModuleData;
}

function* getLayoutModels(res, facetsResponse, apiConfig) {
  let { banner: { banners } = {} } = facetsResponse || {};
  if (!banners) {
    banners = res?.banner?.banners;
  }
  const contentData = banners && parseContentData(banners);
  const config = apiConfig || getAPIConfig();
  yield fork(fetchModulesAndLayout, contentData, config, true);
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function* fetchBucketedL2Products(
  currentPageData,
  currentNavIds,
  xappURLConfig,
  currentPageNumber,
  currentCategory,
  facetsPayload = {},
  isHydrating = false,
  apiConfig,
  eSpotPlpPromo,
  { eSpotConditionMet, isSubCategoryFilter }
) {
  try {
    yield put(setBucketLoadingFlag(true));
    const isL2Category = getIsL2Category(currentCategory, facetsPayload, isSubCategoryFilter);
    const filterableSubCategories = yield select(getSubCatFilterMaps);
    if (Array.isArray(currentPageData)) {
      let bucketLength = 0;
      while (bucketLength < currentPageData.length) {
        const l3category = currentPageData[bucketLength];
        const { id, name, rows, start } = l3category;
        const l3ESpotPlpPromo = findESpotById(id, eSpotPlpPromo);
        const categoryPathMap = [...currentNavIds, id];
        const categoryPathId = categoryPathMap?.join('>');
        const l2BucketResponse = yield call(fetchPlpProducts, {
          rows,
          start,
          xappURLConfig,
          categoryPathId,
          skipFacets: !isSubCategoryFilter,
          facetsPayload,
          apiConfig,
        });
        let eSpotPlpPromoContent = {};
        if (eSpotConditionMet && !isEmpty(l3ESpotPlpPromo)) {
          eSpotPlpPromoContent = yield call(fetchModuleDynamic, l3ESpotPlpPromo);
        }
        const { response: { products = [] } = {}, facets: { text: { list = [] } = {} } = {} } =
          l2BucketResponse || {};

        const l2Title = {
          id,
          name,
          isTitle: true,
        };
        yield put(setIsProductLoading(false));
        yield put(
          setBucketedPaginatedProducts({
            data: isL2Category
              ? [
                  l2Title,
                  ...(!isEmpty(eSpotPlpPromoContent) ? [eSpotPlpPromoContent] : []),
                  ...products,
                ]
              : [...products],
            page: currentPageNumber,
            isHydrating: isHydrating && !bucketLength,
          })
        );
        yield put(
          setConsolidatedPlpRes({
            isShowL2Skeleton: false,
          })
        );
        bucketLength += 1;
        if (isSubCategoryFilter) {
          const matchedSubCat = filterableSubCategories.find((subCat) => subCat.id === id);
          if (matchedSubCat) {
            yield put(setSubCatFacetList({ name, list }));
          }
        }
      }
    } else {
      const { id, name, rows, start } = currentPageData || {};
      const categoryPathId =
        isL2Category && id ? [...currentNavIds, id].join('>') : currentNavIds?.join('>');
      const l3ESpotPlpPromo = findESpotById(id, eSpotPlpPromo);
      const l2Title = {
        id,
        name,
        isTitle: true,
      };
      const res = yield call(fetchPlpProducts, {
        rows,
        start,
        xappURLConfig,
        categoryPathId,
        skipFacets: true,
        facetsPayload,
        apiConfig,
      });
      let eSpotPlpPromoContent = {};
      if (eSpotConditionMet && !isEmpty(l3ESpotPlpPromo)) {
        eSpotPlpPromoContent = yield call(fetchModuleDynamic, l3ESpotPlpPromo);
      }
      const { response: { products = [] } = {} } = res || {};
      yield put(setIsProductLoading(false));
      yield put(
        setPaginatedPlpData({
          data:
            isL2Category && id
              ? [
                  l2Title,
                  ...(!isEmpty(eSpotPlpPromoContent) ? [eSpotPlpPromoContent] : []),
                  ...products,
                ]
              : [...products],
          page: currentPageNumber,
          isHydrating,
        })
      );
    }
  } catch (error) {
    if (error?.isServiceError) {
      yield put(setServiceErrorFlag(true));
    }
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - fetchBucketedL2Products catch - ${error}`,
      extraData: {
        componentName: 'CategoryListingPageSaga',
        methodName: 'fetchBucketedL2Products',
        isServiceError: error?.isServiceError || false,
      },
    });
  } finally {
    if (Array.isArray(currentPageData) ? currentPageData.length : !!currentPageData) {
      yield put(setBucketLoadingFlag(false));
    }
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function* handleL2CategoryWithFacet({
  currentNavIds,
  xappURLConfig,
  facetsPayload,
  recordsPerPage,
  currentCategory,
  filtersFromUrl,
  breadCrumbs,
  currentPageNumber,
  apiConfig,
  isBopisFilterOn,
  appliedSortId,
  isSortOrFilter,
  isHydrating,
  pathName,
  isServer,
  eSpotPlpPromo,
  eSpotConditionMet,
  skipFacetsNew,
  isSubCategoryFilter,
}) {
  try {
    const isCleanUrlForSizeEnabled = yield select(getIsCleanUrlForSizeEnabled);
    const isQuickFiltersEnabled = yield select(getIsQuickFiltersEnabled);
    const isSubCatFilterMapsLoaded = yield select(getSubCatFilterMapsLoaded);
    const facetsCategoryPathId = currentNavIds?.join('>');
    const facetsResponse = yield call(fetchPlpProducts, {
      rows: 0,
      start: 0,
      xappURLConfig,
      categoryPathId: facetsCategoryPathId,
      isFacetsCall: true,
      facetsPayload: skipFacetsNew ? {} : facetsPayload,
      apiConfig,
    });
    const { facets, stats } = facetsResponse || {};
    let updatedFacets = facets;
    let appliedSubCatFilters = [];

    if (!isSubCatFilterMapsLoaded) {
      const filterableSubCategories = getSubCategoryForFiltering(facets, currentCategory);
      yield put(setSubCatFilterMapsData(filterableSubCategories));
    }

    if (isSubCategoryFilter) {
      const { filter_cat_grp: filterCatGrp } = filtersFromUrl;
      appliedSubCatFilters = getAppliedSubCatFilters(filtersFromUrl);
      updatedFacets = filterFacetValues(updatedFacets, filterCatGrp);
    }

    const { unbxdCallByPageNumber, totalProductsCount } = getL2BucketingByPageNumber(
      updatedFacets,
      recordsPerPage,
      currentCategory
    );
    if (!totalProductsCount) {
      const categoryPathId = currentNavIds?.join('>');
      const res = yield call(fetchPlpProducts, {
        rows: recordsPerPage,
        start: (currentPageNumber - 1) * recordsPerPage,
        xappURLConfig,
        categoryPathId,
        skipFacets: false,
        facetsPayload,
        apiConfig,
      });
      const {
        response: { numberOfProducts, products = [] } = {},
        facets: facetsL2,
        stats: statsL2,
      } = res || {};
      const {
        unbxdCallByPageNumber: unbxdCallByPageNumberL2,
        totalProductsCount: totalProductsCountL2,
      } = getUnbxdCallByPageNumber(numberOfProducts, recordsPerPage);
      if (currentPageNumber !== 1 && currentPageNumber > unbxdCallByPageNumberL2.length) {
        const lastPage = unbxdCallByPageNumberL2.length;
        navigationToLastPage(pathName, lastPage);
      }
      yield put(setIsProductLoading(false));
      yield put(setPaginatedPlpData({ data: [...products], page: currentPageNumber, isHydrating }));
      const filtersMaps = getFiltersAfterProcessing(
        facetsL2,
        totalProductsCountL2,
        getFacetSwatchImgPath,
        filtersFromUrl,
        breadCrumbs.length === 1,
        false,
        statsL2,
        isCleanUrlForSizeEnabled
      );
      const appliedFilters = getAppliedFilters(filtersMaps, filtersFromUrl);
      const isQuickFiltersModuleEnabled = yield select(getIsQuickFiltersModuleEnabled);
      if (isAppliedFitersObjectEmpty(filtersFromUrl) && isQuickFiltersModuleEnabled) {
        yield put(setCategoryModuleFilters(getModuleFilters(filtersMaps, filtersFromUrl)));
      }
      if (isQuickFiltersEnabled) {
        yield put(setQuickFilters(extractQuickFiltersFromFilters(filtersMaps)));
      }
      yield put(setIsProductLoading(false));
      yield put(
        setConsolidatedPlpRes({
          filtersMaps,
          totalProductsCount: totalProductsCountL2,
          isPaginatedPlpLoading: false,
          currentNavIds,
          breadCrumbs,
          appliedFilters,
          isBopisFilterOn,
          appliedSortId,
          isL2Category: false,
          isShowL2Skeleton: false,
          isInitialCall: isServer,
          currentPageNumber,
          appliedSubCatFilters,
          ...(isClient() ? { unbxdCallByPageNumber: unbxdCallByPageNumberL2 } : {}),
        })
      );
      if (!isSortOrFilter) yield call(getLayoutModels, res, {}, apiConfig);
    } else {
      yield put(
        setConsolidatedPlpRes({
          totalProductsCount,
          currentNavIds,
          breadCrumbs,
          isBopisFilterOn,
          appliedSortId,
          isL2Category: true,
          appliedSubCatFilters,
          ...(isClient() ? { unbxdCallByPageNumber } : {}),
        })
      );
      if (currentPageNumber !== 1 && currentPageNumber > unbxdCallByPageNumber.length) {
        const lastPage = unbxdCallByPageNumber.length;
        navigationToLastPage(pathName, lastPage);
      }
      const currentPageData = unbxdCallByPageNumber[currentPageNumber - 1];
      if (totalProductsCount && currentPageData && !skipFacetsNew) {
        yield call(
          fetchBucketedL2Products,
          currentPageData,
          currentNavIds,
          xappURLConfig,
          currentPageNumber,
          currentCategory,
          facetsPayload,
          isHydrating,
          apiConfig,
          eSpotPlpPromo,
          { eSpotConditionMet, isSubCategoryFilter }
        );
      } else if (!skipFacetsNew) {
        yield put(setPaginatedPlpData({ data: [], page: currentPageNumber, isHydrating }));
      }

      const l3FacetMapList = yield select(getSubCatFacetList);

      if (isSubCategoryFilter && Array.isArray(l3FacetMapList) && l3FacetMapList.length > 0) {
        updatedFacets = getUpdatedFacetsList(l3FacetMapList, appliedSubCatFilters, updatedFacets);
      }

      const filtersMaps = getFiltersAfterProcessing(
        updatedFacets,
        totalProductsCount,
        getFacetSwatchImgPath,
        filtersFromUrl,
        breadCrumbs.length === 1,
        false,
        stats,
        isCleanUrlForSizeEnabled
      );
      const appliedFilters = getAppliedFilters(filtersMaps, filtersFromUrl);
      const isQuickFiltersModuleEnabled = yield select(getIsQuickFiltersModuleEnabled);

      if (
        isQuickFiltersModuleEnabled &&
        !isSubCategoryFilter &&
        (!(
          hasSelectedFacets(updatedFacets) ||
          containsOnlyOneKey(facetsPayload?.filter, 'min_offer_price')
        ) ||
          isAppliedFitersObjectEmpty(filtersFromUrl))
      ) {
        yield put(setCategoryModuleFilters(getModuleFilters(filtersMaps, filtersFromUrl)));
      }
      if (isQuickFiltersEnabled && !isSubCategoryFilter) {
        yield put(setQuickFilters(extractQuickFiltersFromFilters(filtersMaps)));
      }

      yield put(setIsProductLoading(false));
      yield put(
        setConsolidatedPlpRes({
          isPaginatedPlpLoading: false,
          isInitialCall: isServer,
          isShowL2Skeleton: false,
          filtersMaps,
          appliedFilters,
          appliedSubCatFilters,
        })
      );
      if (!isSortOrFilter) yield call(getLayoutModels, {}, facetsResponse, apiConfig);
    }
  } catch (err) {
    yield put(setIsProductLoading(false));
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - handleL2CategoryWithFacet catch - ${err}`,
      extraData: {
        component: 'CategoryListingPageSaga',
        methodName: 'handleL2CategoryWithFacet',
        pathName,
      },
    });
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function* fetchInitialProductsWithFacets({ payload }) {
  try {
    const {
      pathName,
      recordsPerPage,
      apiConfig,
      currentPageNumber = 1,
      isSortOrFilter,
      filters,
      isInitialCall,
      isServer,
      isInitialClientCall,
      initialBreadCrumb,
      isQuickFiltersModuleEnabled,
      doNotUseFacets,
      isSubCategoryFilter,
    } = payload;
    yield put(setServiceErrorFlag(false));
    yield put(setConsolidatedPlpRes({ isInitialCall }));
    const isFacetedNavigationEnabled = yield select(getIsFacetedNavigationEnabled);
    const seoFacetedNavigationConfig = yield select(getSeoFacetedNavigationConfig);
    const isCleanUrlForSizeEnabled = yield select(getIsCleanUrlForSizeEnabled);
    const isESpotPromoL1PlpEnabled = yield select(getIsESpotPromoL1PlpEnabled);
    const isESpotPromoL2PlpEnabled = yield select(getIsESpotPromoL2PlpEnabled);
    const isESpotPromoL3PlpEnabled = yield select(getIsESpotPromoL3PlpEnabled);
    const isESpotPlpBackABTestDisabled = yield select(getIsESpotPlpBackABTest);
    const isQuickFiltersEnabled = yield select(getIsQuickFiltersEnabled);
    const isESpotPromoL2PlpWithCategoryBreakSwitchEnabled = yield select(
      getIsESpotPromoL2PlpWithCategoryBreakEnabled
    );
    const isESpotPromoL2PlpWithCategoryBreakEnabled =
      isESpotPromoL2PlpWithCategoryBreakSwitchEnabled && !isESpotPlpBackABTestDisabled;
    const eSpotConditionMet =
      isESpotPromoL2PlpWithCategoryBreakEnabled ||
      isESpotPromoL1PlpEnabled ||
      isESpotPromoL2PlpEnabled ||
      isESpotPromoL3PlpEnabled;
    const filterMaps = yield select(getFilterMaps);
    let clothingsize = {};
    let eSpotPlpPromo = {};
    if (isSubCategoryFilter) {
      yield put(setSubCategoryFilterLoading(true));
    }
    if (isCleanUrlForSizeEnabled && filterMaps?.v_clothingsize_uFilter) {
      clothingsize = filterMaps.v_clothingsize_uFilter;
    }
    const isHydrating = (isInitialCall || isInitialClientCall) && !isServer;
    if (!isInitialCall) yield put(resetPaginatedProducts());
    const { facetsPayload, filtersFromUrl, isBopisFilterOn } = isFacetedNavigationEnabled
      ? getFiltersPayloadSeo(
          pathName,
          filters,
          isFacetedNavigationEnabled,
          seoFacetedNavigationConfig,
          {
            isCleanUrlForSizeEnabled,
            clothingSizeMap: clothingsize,
          }
        )
      : getFiltersPayload(pathName, filters);
    let appliedFilters = getAppliedFilters(filterMaps, filtersFromUrl);
    yield put(updateAppliedFilter(appliedFilters));
    yield put(updateFilterFromURL(filtersFromUrl));
    const { sort: appliedSortId } = filtersFromUrl || {};
    let breadCrumbs = initialBreadCrumb;
    if (!breadCrumbs) {
      breadCrumbs = yield select(computedBreadCrumbs);
    }
    const activeCategoryIds = breadCrumbs.map((cat) => cat.catgroupId);
    yield put(setCurrNavIds({ activeCategoryIds }));
    const currentCategory = breadCrumbs[breadCrumbs.length - 1];
    const isL2Category = getIsL2Category(currentCategory, facetsPayload, isSubCategoryFilter);
    const currentNavIds = breadCrumbs?.map((category) => category?.id);
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const skipFacetsNew = isQuickFiltersModuleEnabled && doNotUseFacets && !isSubCategoryFilter;

    if (eSpotConditionMet) {
      eSpotPlpPromo = yield call(getESpotPlpPromo, {
        breadCrumbs,
        isESpotPromoL1PlpEnabled,
        isESpotPromoL2PlpEnabled,
        isESpotPromoL3PlpEnabled,
        isESpotPromoL2PlpWithCategoryBreakEnabled,
      });
    }

    if (isL2Category) {
      yield call(handleL2CategoryWithFacet, {
        currentNavIds,
        xappURLConfig,
        facetsPayload,
        recordsPerPage,
        currentCategory,
        filtersFromUrl,
        breadCrumbs,
        currentPageNumber,
        apiConfig,
        isBopisFilterOn,
        appliedSortId,
        isSortOrFilter,
        isHydrating,
        pathName,
        isServer,
        eSpotPlpPromo,
        eSpotConditionMet,
        skipFacetsNew,
        isSubCategoryFilter,
      });
    } else {
      let eSpotPlpPromoContent = {};
      const categoryPathId = currentNavIds?.join('>');
      const res = yield call(fetchPlpProducts, {
        rows: skipFacetsNew ? 0 : recordsPerPage,
        start: (currentPageNumber - 1) * recordsPerPage,
        xappURLConfig,
        categoryPathId,
        skipFacets: false,
        facetsPayload: skipFacetsNew ? {} : facetsPayload,
        apiConfig,
      });

      const { response: { numberOfProducts, products = [] } = {}, facets, stats } = res || {};
      const { unbxdCallByPageNumber, totalProductsCount } = getUnbxdCallByPageNumber(
        numberOfProducts,
        recordsPerPage
      );
      if (currentPageNumber !== 1 && currentPageNumber > unbxdCallByPageNumber.length) {
        const lastPage = unbxdCallByPageNumber.length;
        navigationToLastPage(pathName, lastPage);
      }
      if (eSpotConditionMet && !isEmpty(eSpotPlpPromo)) {
        eSpotPlpPromoContent = yield call(fetchModuleDynamic, eSpotPlpPromo);
      }
      yield put(setIsProductLoading(false));
      if (!skipFacetsNew) {
        yield put(
          setPaginatedPlpData({
            data: [
              ...(!isEmpty(eSpotPlpPromoContent) && currentPageNumber === 1
                ? [eSpotPlpPromoContent]
                : []),
              ...products,
            ],
            page: currentPageNumber,
            isHydrating,
          })
        );
      }

      const filtersMaps = getFiltersAfterProcessing(
        facets,
        totalProductsCount,
        getFacetSwatchImgPath,
        filtersFromUrl,
        breadCrumbs.length === 1,
        false,
        stats,
        isCleanUrlForSizeEnabled
      );
      appliedFilters = getAppliedFilters(filtersMaps, filtersFromUrl);

      if (
        (isAppliedFitersObjectEmpty(filtersFromUrl) || skipFacetsNew) &&
        isQuickFiltersModuleEnabled &&
        !isSubCategoryFilter
      ) {
        yield put(setCategoryModuleFilters(getModuleFilters(filtersMaps)));
      }
      if (isQuickFiltersEnabled && !isSubCategoryFilter)
        yield put(setQuickFilters(extractQuickFiltersFromFilters(filtersMaps)));
      // setLocalStorage({ key: 'appliedFilters', value: JSON.stringify(filtersFromUrl) });
      yield put(setIsProductLoading(false));
      yield put(
        setConsolidatedPlpRes({
          filtersMaps,
          totalProductsCount,
          isPaginatedPlpLoading: false,
          currentNavIds,
          breadCrumbs,
          appliedFilters,
          isBopisFilterOn,
          appliedSortId,
          isL2Category,
          isInitialCall: isServer,
          currentPageNumber,
          ...(isClient() ? { unbxdCallByPageNumber } : {}),
        })
      );
      if (!isSortOrFilter) yield call(getLayoutModels, res, {}, apiConfig);
    }
    yield put(setCurrentPageNo(currentPageNumber));
    if (isSubCategoryFilter) {
      yield put(setSubCategoryFilterLoading(false));
    }
  } catch (error) {
    if (error?.isServiceError) {
      yield put(setServiceErrorFlag(true));
    }
    yield put(setIsProductLoading(false));
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - fetchInitialProductsWithFacets catch - ${error}`,
      extraData: {
        component: 'CategoryListingPageSaga',
        methodName: 'fetchInitialProductsWithFacets',
        payloadRecieved: payload,
        isServiceError: error?.isServiceError || false,
      },
    });
    yield put(
      setConsolidatedPlpRes({
        totalProductsCount: 0,
        isPaginatedPlpLoading: false,
        isInitialCall: false,
        paginatedPlpProducts: [],
      })
    );
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function* fetchPaginatedProducts({ payload }) {
  try {
    const { currentPageNumber } = payload;
    let plpProducts = [];
    let currentPage = [];
    let eSpotPlpPromo = {};
    yield put(setServiceErrorFlag(false));
    const isTimeOver = yield select(isCachedTimeOver);
    const isESpotPromoL1PlpEnabled = yield select(getIsESpotPromoL1PlpEnabled);
    const isESpotPromoL2PlpEnabled = yield select(getIsESpotPromoL2PlpEnabled);
    const isESpotPromoL3PlpEnabled = yield select(getIsESpotPromoL3PlpEnabled);
    const isESpotPlpBackABTestDisabled = yield select(getIsESpotPlpBackABTest);
    const isESpotPromoL2PlpWithCategoryBreakSwitchEnabled = yield select(
      getIsESpotPromoL2PlpWithCategoryBreakEnabled
    );
    const isESpotPromoL2PlpWithCategoryBreakEnabled =
      isESpotPromoL2PlpWithCategoryBreakSwitchEnabled && !isESpotPlpBackABTestDisabled;
    const eSpotConditionMet =
      isESpotPromoL2PlpWithCategoryBreakEnabled ||
      isESpotPromoL1PlpEnabled ||
      isESpotPromoL2PlpEnabled ||
      isESpotPromoL3PlpEnabled;
    if (isTimeOver) {
      yield put(resetPaginatedProducts());
      yield put(resetCachedTiming());
    } else {
      plpProducts = yield select(getCategoryProducts) || [];
      currentPage = (plpProducts && plpProducts[currentPageNumber - 1]) || [];
    }
    if (!currentPage.length) {
      yield put(setPaginatedPlpLoading(true));
      const filters = yield select(getInitialValues);
      const facetsPayload = isEmpty(filters) ? {} : extractFilters(filters);
      if (filters?.sort) {
        facetsPayload.sort = filters.sort;
      }
      const breadCrumbs = yield select(computedBreadCrumbs);
      const currentCategory = breadCrumbs[breadCrumbs.length - 1];
      const currentNavIds = breadCrumbs.map((category) => category?.id);
      const unbxdCallByPageNumber = yield select(getUnbxdPageNo) || [];
      const xappURLConfig = yield call(getUnbxdXappConfigs);
      const currentPageData = unbxdCallByPageNumber[currentPageNumber - 1];

      if (eSpotConditionMet) {
        eSpotPlpPromo = yield call(getESpotPlpPromo, {
          breadCrumbs,
          isESpotPromoL1PlpEnabled,
          isESpotPromoL2PlpEnabled,
          isESpotPromoL3PlpEnabled,
          isESpotPromoL2PlpWithCategoryBreakEnabled,
        });
      }

      yield call(
        fetchBucketedL2Products,
        currentPageData,
        currentNavIds,
        xappURLConfig,
        currentPageNumber,
        currentCategory,
        facetsPayload,
        undefined,
        undefined,
        eSpotPlpPromo,
        { eSpotConditionMet }
      );
      yield put(setPaginatedPlpLoading(false));
    }
    yield put(setIsProductLoading(false));
    yield put(setConsolidatedPlpRes({ currentPageNumber }));
  } catch (error) {
    if (error?.isServiceError) {
      yield put(setServiceErrorFlag(true));
    }
    logger.error({
      error: `Error in CategoryListingPageSaga - fetchPaginatedProducts catch ${error}`,
      extraData: {
        component: 'CategoryListingPageSaga - fetchPaginatedProducts',
        payloadRecieved: payload,
        isServiceError: error?.isServiceError || false,
      },
    });
    const { currentPageNumber } = payload;
    yield put(setIsProductLoading(false));
    yield put(
      setConsolidatedPlpRes({
        isPaginatedPlpLoading: false,
        currentPageNumber,
        paginatedPlpProducts: [],
      })
    );
  }
}

// To load facets for hplp.
function* fetchInitialProductsWithFacetsWrapper({ payload }) {
  try {
    let { cid } = payload;
    if (cid.includes('/')) {
      [cid] = cid.split('/');
    }
    const { plpPayload } = getPlpPayload(payload);
    const isHplpEnabled = yield select(getIsHorizontalPlpEnabled);
    const breadCrumbs = yield select(getBreadCrumbs(cid));
    const isAltplpEnabled = yield select(getIsAlternatePLPEnabled);
    const navigationData = yield select(getNavigationData);
    const isOutFitEnabled = yield select(getIsOutfitPLPEnabled);
    const isHplpFiltersEnabled = yield select(getIsHplpFiltersEnabled);

    const navTree = getNavigationTree(navigationData, payload?.pathName?.trim());
    // category Checks for HPLP APLP
    const isHplpCategoryEnabled = getplpHlpAplpChecks(
      breadCrumbs,
      navigationData,
      navTree,
      isAltplpEnabled,
      isHplpEnabled,
      isOutFitEnabled,
      true
    )?.isHplpCategoryEnabled;
    if (isHplpCategoryEnabled && isHplpFiltersEnabled) {
      yield call(fetchHorizontalCategoryProducts, {
        payload: { ...plpPayload, callForFacets: true },
      });
    } else {
      yield call(fetchInitialProductsWithFacets, { payload });
    }
  } catch (error) {
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - fetchInitialProductsWithFacetsWrapper catch - ${error}`,
      extraData: {
        component: 'CategoryListingPageSaga - fetchInitialProductsWithFacetsWrapper',
        payloadRecieved: payload,
      },
    });
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function* fetchInitialCategory({ payload }) {
  try {
    if (isClient()) yield put(resetSeoHeaderCopyLoadedFlag());
    if (isClient()) yield put(resetSubCatFilterMapsLoadedFlag());
    const { isInitialClientCall, resolve, skipCategoryCall, isSubCategoryFilter } = payload;
    let { cid } = payload;

    const { bootstrapPayload, plpPayload } = getPlpPayload(payload);
    const previousLayoutData = yield select(getLayoutProductListingPageData);
    if (cid.includes('/')) {
      [cid] = cid.split('/');
    }
    /*
      if previousLayoutData.cid is not same as current cid then update only fetched: false, so that promo data becomes null
      Otherwise update same previous data to avoid rerender of skeleton on ssr condition
    */
    if (previousLayoutData?.cid !== cid) {
      yield put(loadLayoutData({ fetched: false, cid }, 'productListingPage'));
    } else {
      yield put(
        loadLayoutData({ ...previousLayoutData, fetched: true, cid }, 'productListingPage')
      );
    }

    if (!isClient()) yield call(bootstrap, bootstrapPayload);
    if (skipCategoryCall) {
      yield put(setIsProductLoading(false));
      yield put(
        setConsolidatedPlpRes({
          totalProductsCount: 0,
          isPaginatedPlpLoading: false,
          paginatedPlpProducts: [],
        })
      );
      resolveCategoryCall(resolve, false);
      return;
    }
    const breadCrumbs = yield select(getBreadCrumbs(cid));
    const isAltplpEnabled = yield select(getIsAlternatePLPEnabled);
    const isHplpEnabled = yield select(getIsHorizontalPlpEnabled);
    const isStageHoldCategoriesOosEnabled = yield select(getIsStageHoldCategoriesOosEnabled);
    const navigationData = yield select(getNavigationData);
    const isOutFitEnabled = yield select(getIsOutfitPLPEnabled);
    const HPLPCategories = yield select(getHorizontalCarouselPLPCatIds);
    const pathName = payload?.pathName?.trim();
    const navTree = getNavigationTree(navigationData, pathName);
    yield put(setQuickFilters({}));
    yield put(setCategoryModuleFilters({}));
    // category Checks for HPLP APLP, added check for stage hold categories.
    const plpChecks = getplpHlpAplpChecks(
      breadCrumbs,
      navigationData,
      navTree,
      isAltplpEnabled,
      isHplpEnabled,
      isOutFitEnabled,
      true,
      '',
      HPLPCategories,
      isStageHoldCategoriesOosEnabled
    );
    const { isAplpCategoryEnabled, isHplpCategoryEnabled, isStageHoldCategory } = plpChecks;
    if (breadCrumbs && breadCrumbs.length) {
      // To reset selection when toggling between HPLP and APLP categories
      yield put(setConsolidatedPlpRes({ breadCrumbs }));
      const activeCategoryIds = breadCrumbs.map((cat) => cat.catgroupId);
      // HPLP template categories check
      const isHorizontalPlpEnabled = isHplpEnabled && isHplpCategoryEnabled && l3Check(breadCrumbs);
      // APLP template categories check
      const isPaginatedAltplpEnabled = yield select(getIsPaginatedAlternatePLPEnabled);
      const APLPPaginatedCategories = yield select(getPaginatedAlternatePLPCatIds);

      const isAlternatePlpEnabled =
        isAltplpEnabled && isAplpCategoryEnabled && l3Check(breadCrumbs);

      const isPaginatedAlternatePlpEnabled =
        isPaginatedAltplpEnabled &&
        isAltplpEnabled &&
        APLPPaginatedCategories.includes(activeCategoryIds[activeCategoryIds.length - 1]);

      yield put(setCurrNavIds({ activeCategoryIds }));
      if (isHorizontalPlpEnabled) {
        if (isAltplpEnabled) yield put(setAlternatePlpFlag(false));
        yield put(setHorizontalPlpFlag(isHorizontalPlpEnabled));
        if (!isInitialClientCall && isClient()) {
          yield delay(750);
        }
        yield call(fetchHorizontalCategoryProducts, { payload: { ...plpPayload } });
        yield put(setConsolidatedPlpRes({ isInitialCall: true }));
      } else if (isAlternatePlpEnabled) {
        yield put(setHorizontalPlpFlag(false));
        yield put(setAlternatePlpFlag(isAlternatePlpEnabled));
        if (!isInitialClientCall && isClient()) {
          yield delay(750);
        }
        yield call(fetchHorizontalCategoryProducts, {
          payload: { ...plpPayload, isAlternatePlpEnabled },
        });
      } else if (isStageHoldCategoriesOosEnabled && isStageHoldCategory) {
        yield put(setStageHoldCategoryFlag(true));
      } else {
        yield put(setStageHoldCategoryFlag(false));
        yield put(setAlternatePlpFlag(false));
        yield put(setHorizontalPlpFlag(false));
        yield put(setPaginatedAlternatePlpFlag(isPaginatedAlternatePlpEnabled));
        const { isQuickFiltersModuleEnabled } = plpPayload || {};

        if (
          isQuickFiltersModuleEnabled &&
          !isSubCategoryFilter &&
          (pathName?.split('/')?.length > 4 || !hasOnlyPageParam(pathName))
        ) {
          yield call(fetchInitialProductsWithFacets, {
            payload: { ...plpPayload, initialBreadCrumb: breadCrumbs, doNotUseFacets: true },
          });
        }
        yield call(fetchInitialProductsWithFacets, {
          payload: { ...plpPayload, initialBreadCrumb: breadCrumbs },
        });
      }
      resolveCategoryCall(resolve, true);
      yield put(setIsProductLoading(false));
    } else {
      yield put(setIsProductLoading(false));
      yield put(
        setConsolidatedPlpRes({
          totalProductsCount: 0,
          isPaginatedPlpLoading: false,
          paginatedPlpProducts: [],
        })
      );
      resolveCategoryCall(resolve, false);
    }
  } catch (error) {
    logger.error({
      error: `Error in new plp CategoryListingPageSaga - fetchInitialCategory catch - ${error}`,
      extraData: {
        component: 'CategoryListingPageSaga - fetchInitialCategory',
        payloadRecieved: payload,
      },
    });
    yield put(setIsProductLoading(false));
    yield put(
      setConsolidatedPlpRes({
        totalProductsCount: 0,
        isPaginatedPlpLoading: false,
        paginatedPlpProducts: [],
      })
    );
    resolveCategoryCall(payload?.resolve, true);
  }
}

function* getSEOtokenJSON() {
  try {
    const plpSeoToken = yield select(getSeoTokens);
    if (!plpSeoToken) {
      const responseUS = yield call(getSeoTokenJSONList, 'usToken');
      const responseCA = yield call(getSeoTokenJSONList, 'caToken');
      const responseNoHrefLang = yield call(getSeoTokenJSONList, 'noToken');
      if (!(isEmpty(responseUS) && isEmpty(responseCA) && isEmpty(responseNoHrefLang))) {
        const data = {
          us: responseUS,
          ca: responseCA,
          noHref: responseNoHrefLang,
        };
        yield put(setSEOTokenJSON(data));
      }
    }
  } catch (error) {
    logger.error({
      error: `Error in getSEOtokenJSON`,
      extraData: {
        component: 'CategoryListingPageSaga',
        payloadRecieved: {},
      },
    });
  }
}

function* CategoryListingPageSaga() {
  yield takeLatest(
    CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_INITIAL_PRODUCTS_WITH_FACETS,
    fetchInitialProductsWithFacetsWrapper
  );
  yield takeLatest(CATEGORY_LISTING_PAGE_CONSTANTS.GET_SEO_TOKEN_JSON, getSEOtokenJSON);
  yield takeLatest(
    CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_PAGINATED_PRODUCTS,
    fetchPaginatedProducts
  );
  yield takeLatest(CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_INITIAL_CATEGORY, fetchInitialCategory);
}

export default CategoryListingPageSaga;
